import { useSelector } from "react-redux";

import LocalStorage from "@helpers/local-storage";
import { LOCAL_STORAGE_KEYS } from '@helpers/constants';
import { getGroupHashKey } from "@containers/entities/helpers";
import { useEffect, useState } from "react";

const useGetDefaultUpfCourseId = () => {
  const [defaultUpfCourseId, setDefaultUpfCourseId] = useState(null);
  const classrooms = useSelector(state => state.entitiesReducer.classrooms);
  const groups = useSelector(state => state.entitiesReducer.groups);
  const lastUsedClassroom = LocalStorage.getItem(LOCAL_STORAGE_KEYS.LAST_USED_CLASSROOM)?.value;
  const lastUsedGroup = LocalStorage.getItem(LOCAL_STORAGE_KEYS.LAST_USED_GROUP)?.value;

  useEffect(() => {
    const groupKey = getGroupHashKey({ classroomId: lastUsedClassroom, groupId: lastUsedGroup });
    const defaultClassromUpfCourseId = classrooms[lastUsedClassroom]?.defaultUpfCourseId;
    const defaultGroupUpfCourseId = groups[groupKey]?.defaultUpfCourseId;
  
    setDefaultUpfCourseId(defaultGroupUpfCourseId || defaultClassromUpfCourseId);
  }, [classrooms, groups, lastUsedClassroom, lastUsedGroup])
  
  return defaultUpfCourseId;
}

export default useGetDefaultUpfCourseId;


// WEBPACK FOOTER //
// ./helpers/hooks/use-get-default-upf-course-id.js